// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__49Jjg","left":"styles_left__2ECtV","desktopActions":"styles_desktopActions__21Bdb","title":"styles_title__1J0bA"};